module.exports = __webpack_public_path__ + "img/treasuries.d3ab3564.svg";